let modal = document.querySelector(".modal");
let btnCloseModal = document.querySelector(".modal_btn_close");
let projects = document.querySelectorAll(".boxService");

projects.forEach((project) => {
    let idImage = project.dataset.id;
    async function getProject(idImage) {
        const res = await fetch(`${BASE}/api/project/${idImage}`);
        const project = await res.json();

        mountModal(
            project["image"],
            project["created_at"],
            project["title"],
            project["description"],
            project["url"]
        );
    }

    project.addEventListener("click", () => {
        modal.style.display = "flex";
        getProject(idImage);

    });
});

modal.addEventListener("click", ({ target, currentTarget }) => {
    if (target === currentTarget || target === btnCloseModal) {
        modal.style.display = "none";
    }
});

function mountModal(image, dateProject, titleProject, descProject, urlProject) {
    document.querySelector(".modal_img img").src = `${BASE}/storage/` + image;
    document.querySelector(".modal_img img").alt = titleProject;
    document.querySelector(".date_project").innerHTML = dateProject;
    document.querySelector(".title_project").innerHTML = titleProject;
    document.querySelector(".description_project").innerHTML = descProject;

    if (urlProject === null) {
        document.querySelector(".modal_data a").innerHTML = "";
    }
    document.querySelector(".modal_data a").innerHTML = urlProject;
    document.querySelector(".modal_data a").href = urlProject;
}
